import { useI18n } from '../../i18n/useI18n';
import { actorKind, actorLabel, delegatedBy } from './auditActor';

/**
 * Who acted, with what they are marked beside the name.
 *
 * A person is left plain: most rows are people, and a mark on every row marks
 * nothing. A workload and an agent are chipped, because reading either as a
 * person is the mistake this column exists to prevent — and an agent's chip
 * names whose access it is borrowing, which is the fact somebody reading an
 * audit trail actually needs.
 */
export function ActorMark({ actor }: { actor: string }) {
  const { t } = useI18n();
  const kind = actorKind(actor);
  const owner = delegatedBy(actor);

  return (
    <span className="mono" title={actor}>
      {actorLabel(actor)}
      {kind === 'agent' && (
        <>
          {' '}
          <span className="chip key" title={t('audit.actor.agent.why')}>
            {owner === undefined ? t('audit.actor.agent') : t('audit.actor.agent.of', { owner })}
          </span>
        </>
      )}
      {kind === 'workload' && (
        <>
          {' '}
          <span className="chip" title={t('audit.actor.workload.why')}>
            {t('audit.actor.workload')}
          </span>
        </>
      )}
    </span>
  );
}
